import Axios from "axios";
import { buscaCepViaCep } from "@/services/viaCep";

class ClienteDataService {
  criaEndereco(params) {
    return Axios.post("/clienteEnderecos", params);
  }

  getAll() {
    return Axios.get("clientes");
  }

  getActive() {
    return Axios.get("clientes/active");
  }

  getPage(params) {
    return Axios.get("clientes/page", { params });
  }

  search(params = {}) {
    return Axios.get("clientes/search", { params });
  }

  create(params) {
    return Axios.post("clientes", params);
  }

  update(params) {
    return Axios.put("clientes/" + params.id, params);
  }

  updateEmail(id, params) {
    return Axios.put(`clientes/${id}/email`, params);
  }

  find(id) {
    return Axios.get(`clientes/${id}`);
  }

  delete(id) {
    return Axios.delete(`clientes/${id}`);
  }

  getUser() {
    return Axios.get(`usuarios/dados_Usuario/simplified`);
  }

  getPermissoes() {
    return Axios.get(`usuarios/permissoes`);
  }

  getCidades() {
    return Axios.get(`cidades`);
  }

  updateEnderecoCliente(params) {
    console.log(params);
    return Axios.put(`clienteEnderecos/${params.id}`, params);
  }

  deleteEnderecoCliente(id) {
    return Axios.delete(`clienteEnderecos/${id}`);
  }

  buscaCep(value) {
    return buscaCepViaCep(value);
  }
  export(params) {
    return Axios.put("clientes/export", params);
  }

  getFilterPage(payload, params) {
    return Axios.post("clientes/filter/page", payload, { params });
  }

  importContaContabil(params) {
    return Axios.post("clientes/importContaContabil", params);
  }
  getFilter(params) {
    return Axios.post("clientes/filter", params);
  }
}

export default new ClienteDataService();
